import { useState } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import RichTooltip from 'LuxKit/RichTooltip'

const LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY = 'le_lux_exclusive_tooltip_shown'

interface Props {
  children: React.ReactNode
  autoOpenOnce?: boolean
  variant?: 'light' | 'dark'
}

function LtleTooltipWrapper({ children, autoOpenOnce = false, variant = 'dark' }: Props) {
  const intl = useIntl()

  const [shouldAutoOpen] = useState(() => {
    if (!autoOpenOnce) return false
    if (typeof window === 'undefined') return false
    try {
      if (localStorage.getItem(LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY) === 'true') return false
      localStorage.setItem(LUX_EXCLUSIVE_TOOLTIP_SHOWN_KEY, 'true')
    } catch { return false }
    return true
  })

  const tooltipText = intl.formatMessage({
    id: '80HRey_vvUla5V-IAD0Z',
    defaultMessage: 'Limited-time offers you won’t find anywhere else, handpicked and curated by our team with our best price guarantee!',
    description: 'Tooltip describing Limited Time Lux Exclusive offers',
  })

  return (
    <RichTooltip
      variant={variant}
      description={tooltipText}
      placement="top-start"
      showOnHover
      portaled
      forcePointerEvents
      defaultOpen={shouldAutoOpen}
      dismissible={shouldAutoOpen}
      closeOnOutsideClick={shouldAutoOpen}
      maxWidth={400}
    >
      {children}
    </RichTooltip>
  )
}

export default LtleTooltipWrapper
